export const fetchAllPaginatedPages = async <
  TItem,
  TParams extends { offset?: number; limit?: number },
>(
  fetchPage: (params: TParams, signal?: AbortSignal) => Promise<TItem[]>,
  params: TParams,
  signal?: AbortSignal,
): Promise<TItem[]> => {
  const limit = params.limit ?? 100;
  const items: TItem[] = [];
  let offset = 0;
  let page: TItem[];

  do {
    page = await fetchPage({ ...params, offset, limit }, signal);
    items.push(...page);
    offset += limit;
  } while (page.length === limit);

  return items;
};
